import React from "react";
import { Link } from "react-router-dom";

class Page5 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 5) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div>
            <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <h3 className="py-0 d-md-block">Learning Points</h3>
                </li>
                <li className="nav-item"></li>
              </ul>
            </nav>

            <div className="container-fluid h-100 vertical-center ">
              <div className="row h-100 justify-content-center">
                <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                  <div className="card mb-4 box-shadow" id="pageContent">
                    <div className="card-body d-flex flex-column text-dark">
                      <span id="moduleContentText_2">
                        <p>
                          <ol>
                            <li>
                              The job market is changing, stay flexible and open
                              to opportunities.
                            </li>
                            <br />
                            <li>
                              Don’t put too much pressure on any single
                              decision. Choosing the wrong job does not mean the
                              end of your career, experience and skills will
                              always be of value.
                            </li>
                            <br />
                            <li>
                              You career choice or decision isn’t final and
                              decision making can be easier if you have a
                              framework. You may find it helpful to have a go at
                              some of our{" "}
                              <Link to="/Module3" target="_blank">
                                other modules
                              </Link>
                              .
                            </li>
                          </ol>
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page5;
